import React, { useState, useEffect } from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import SiteMapBrowser from "./sitemap-browser"

const SiteMapHome = () => {
  return (
    <SidePanelLayout
      menuName="AdminSitemapMenu"
      tabs={{
        browser: SiteMapBrowser,
      }}
    />
  )
}

export default SiteMapHome
